export default __webpack_public_path__ + "static/isologo-38a2b8f2f76b075c99f48cb4cf481abf.svg";